:host {
  display: contents;

  @media print {
    display: none;
  }
}

.stzh-scrollup {
  display: contents;
}
